import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { sendEmailVerification } from "firebase/auth";

export default function VerifyEmail() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [resent, setResent] = useState(false);
  const [checking, setChecking] = useState(false);

  async function handleResend() {
    try {
      await sendEmailVerification(currentUser);
      setResent(true);
      setTimeout(() => setResent(false), 5000);
    } catch (err) {
      console.error(err);
    }
  }

  async function handleContinue() {
    setChecking(true);
    await currentUser.reload();
    if (currentUser.emailVerified) {
      navigate("/");
    } else {
      setChecking(false);
      alert("Your email hasn't been verified yet. Please check your inbox.");
    }
  }
useEffect(() => {
  if (currentUser?.emailVerified) {
    navigate("/");
  }
}, [currentUser, navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#F0F1EC" }}>
      <div className="max-w-lg w-full mx-auto px-6">
        <div className="card p-10 text-center">
          <div className="text-6xl mb-6">📧</div>
          <h2 className="font-display text-5xl tracking-wider mb-3" style={{ color: "#0A0B0F" }}>
            CHECK YOUR EMAIL
          </h2>
          <p className="font-condensed text-gray-400 tracking-wide text-lg mb-2">
            We've sent a verification link to:
          </p>
          <p className="font-condensed text-xl tracking-wide mb-8" style={{ color: "#0A0B0F" }}>
            {currentUser?.email}
          </p>
          <p className="font-condensed text-gray-400 tracking-wide text-sm mb-8">
            Click the link in the email to verify your account, then come back here and press Continue.
          </p>

          <button
            onClick={handleContinue}
            disabled={checking}
            className="btn-lime w-full py-4 rounded-xl text-xl mb-4"
          >
            {checking ? "CHECKING..." : "I'VE VERIFIED — CONTINUE"}
          </button>

          <button
            onClick={handleResend}
            disabled={resent}
            className="font-condensed tracking-wide text-base w-full py-3 rounded-xl transition"
            style={{ border: "1px solid #E0E2DB", color: resent ? "#3A6600" : "#888" }}
          >
            {resent ? "✓ Email resent!" : "Resend verification email"}
          </button>

          <p className="font-condensed text-gray-400 text-sm mt-6 tracking-wide">
            Check your spam folder if you can't find the email
          </p>
        </div>
      </div>
    </div>
  );
}